module.exports = __webpack_public_path__ + "static/pepetwo-c1cde75fd93815d563eb23af6629476e.png";